import { z } from "zod";

import { AccountSchema, UserSchema } from "../models";

export const ProfileDetailSchema = UserSchema.extend({
  account: AccountSchema
});
export type ProfileDetail = z.infer<typeof ProfileDetailSchema>;

// Create profile schema (without id, createdAt, updatedAt)
export const CreateUserProfileSchema = UserSchema.omit({
  id: true,
  username: true,
  rank: true,
  zaloId: true,
  firebaseId: true,
  createdAt: true,
  updatedAt: true
}).extend({
  referrerCode: z.string().optional()
});
export type CreateUserProfile = z.infer<typeof CreateUserProfileSchema>;

// Update profile schema (partial, without id, userId, createdAt, updatedAt)
export const UpdateUserProfileSchema = CreateUserProfileSchema.partial();
export type UpdateUserProfile = z.infer<typeof UpdateUserProfileSchema>;

// Set avatar schema
export const SetAvatarSchema = z.object({
  avatar: z.string().url()
});
export type SetAvatar = z.infer<typeof SetAvatarSchema>;
